import { createClient } from 'graphql-ws';
import { defaultTo, prop, isNotNil } from 'ramda';
const {
  Environment,
  Network,
  Observable,
  RecordSource,
  Store
} = require('relay-runtime');

export let environment;

const GQLEnvironment = async (token) => {
  const sendRequest = async (url, headers, body, refreshToken = false) => {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      withCredentials: true,
      headers: {
        ...headers,
        token
      },
      body
    });

    if (response.status === 200) {
      return await response.json();
    }

    let errorMessage = null;

    if (response.status === 401) {
      if (refreshToken) {
        return await sendRequest(url, headers, body, true);
      }
      errorMessage = 'can not refresh access token';
    }

    return new Error(defaultTo('graphql request failed')(errorMessage));
  };

  const fetchQuery = async (operation, variables) => {
    let body = new FormData();
    body = JSON.stringify({
      query: operation.text,
      variables,
      operationName: operation.name // Add operationName for authentication & identify which operation is authorized in public mode
    });
    const headers = {
      Accept: '*/*',
      'Content-Type': 'application/json'
    };

    return await sendRequest('/graphql', headers, body);
  };

  const graphqlWsUrl = async () => {
    const response = await fetch('/graphqlwsurl');
    return prop('url', await response.json());
  };

  const wsClient = createClient({ url: graphqlWsUrl });

  const subscribe = (operation, variables) => {
    return Observable.create((sink) => {
      return wsClient.subscribe(
        {
          operationName: operation.name,
          query: operation.text,
          variables
        },
        sink
      );
    });
  };

  return new Environment({
    network: Network.create(fetchQuery, subscribe),
    store: new Store(new RecordSource())
  });
};

export const getEnvironment = async (token) => {
  if (isNotNil(token) || !environment) {
    environment = await GQLEnvironment(token);
  }
  return environment;
};

export default GQLEnvironment;
